export const onAutocompleteChangeInForm =
  ({ setInForm, validateField }) =>
  (e, value) => {
    const target =
      e.currentTarget.querySelector('[data-fieldname]') ||
      e.currentTarget.querySelector('[name]') ||
      e.currentTarget;

    if (target) {
      const { fieldname } = target.dataset;
      const { name } = target;
      const { fieldName, fieldValue } = { fieldName: fieldname || name, fieldValue: value || '' };

      setInForm(fieldName, fieldValue);

      if (validateField) {
        validateField(fieldName, fieldValue);
      }
    }
  };
